export enum FacilityType {
  Tree,
  Bush,
  Flower,
  Building,
  ParkingEnterance,
  Parking,
  Gym,
}
